import * as React from "react";
import {IProfile} from "StateInterface";
import ConsentBox from "consent/utils/consentBox";
import {useEffect, useState} from "react";
import SelectField from "myshubhlife-component/selectField";
import {TextField} from "web-com";
import {COLOR} from "utils/variables";
import Button, {SIZE} from "myshubhlife-component/button";
import {Fields, update} from "userform/utils";
import {downloadPDF} from "utils/download";
import "./index.scss";
import { websiteUrl, imageBaseUrl } from "config";
import {diffYears} from "utils";
import {dateFormat} from "userform/utils";

interface IProps {
    profile: IProfile;
    onComplete: (profile) => void;
    isAndroid: boolean;
}

const regex = {
    name: /^[A-Za-z\\s ]{1,}$/g,
};

const nomineeRelationshipOptions = [{
    name: "Select Nominee Relationship",
    value: "Select Nominee Relationship",
    isDisabled: true,
}, {name: "Father", value: "Father"}, {
    name: "Mother",
    value: "Mother",
}, {name: "Son", value: "Son"}, {name: "Daughter", value: "Daughter"}, {name: "Spouse", value: "Spouse"}];

const minimumAge = 18;
export const InsuranceBundle = (props: IProps) => {
    const [nomineeDetails, updateNomineeDetails] = useState({
        name: "",
        relationShip: "Select Nominee Relationship",
        dob: null,
    });
    const [validation, updateValidation] = useState({
        name: false,
        relationShip: false,
        dob: false,
    });
    useEffect( () => {
       if ( props.profile && props.profile.nominees && props.profile.nominees.length > 0) {
           const { name, relationShip, dob } = props.profile.nominees[0];
           const valName = new RegExp(regex.name).test(name);
           const valDob = dob && (diffYears(new Date(), new Date(dob)) > minimumAge) ? true : false;
           const valRelationShip = relationShip ? true : false;
           updateValidation( { ...validation, name: valName, relationShip: valRelationShip, dob: valDob});
           updateNomineeDetails((prevState) => {
               return {
                   ...prevState,
                   name: name ? name : "",
                   relationShip: relationShip ? relationShip : "",
                   dob: dob ? dob : "",
               };
           });
       }
    }, [] );

    const [agreementChecked, toggleAgreeementCheckbox] = useState(false);

    const relationShipChangeHandler = (fieldName, value) => {
        updateNomineeDetails({
            ...nomineeDetails,
            relationShip: value.toString(),
        });
        updateValidation({
            ...validation,
            relationShip: true,
        });
    };

    const handleProceed = () => {
        let profile = props.profile;
        profile = update(profile, Fields.NOMINEE_NAME, nomineeDetails.name);
        profile = update(profile, Fields.NOMINEE_RELATION, nomineeDetails.relationShip);
        profile = update(profile, Fields.NOMINEE_DOB, nomineeDetails.dob);
        
        props.onComplete({
            nominees: [
                {
                    name:  nomineeDetails.name,
                    relationShip: nomineeDetails.relationShip,
                    dob: nomineeDetails.dob,
                    mobile: null
                }
            ]
        });
    };

    return (
        <ConsentBox pageTitle="Hospicash">
            <div style={{marginTop: "-40px"}}>
                <TextField type="text"
                           placeholder="Enter Nominee Name"
                           value={nomineeDetails.name}
                           fieldName="nomineeName"
                           label="Nominee Name"
                           errorMsg={nomineeDetails.name.length > 0 && !validation.name ? "Please enter correct correct Nominee name" : null}
                           onChange={(fieldName, value) => {
                               updateNomineeDetails({
                                   ...nomineeDetails,
                                   name: value.toString(),
                               });
                               if (!new RegExp(regex.name).test(value.toString())) {
                                   updateValidation({
                                       ...validation,
                                       name: false,
                                   });
                               } else {
                                   updateValidation({
                                       ...validation,
                                       name: true,
                                   });
                               }
                           }}
                />
                <SelectField fieldName="nomineeRelationshipOptions"
                             onChangeHandler={relationShipChangeHandler}
                             options={nomineeRelationshipOptions}
                             value={nomineeDetails.relationShip}
                             name="Nominee Relationship"
                />
                <TextField
                  type="date"
                  value={dateFormat(nomineeDetails.dob)}
                  placeholder="Enter Nominee Date of Birth"
                  fieldName="nomineeDob"
                  label="Nominee Date of birth"
                  errorMsg={nomineeDetails.dob && !validation.dob ? "Nominee cannot be minor!" : ""}
                  onChange={(field, value) => {
                    updateNomineeDetails({...nomineeDetails, dob: value});
                    (diffYears(new Date(), new Date(value)) >= minimumAge) ?
                        updateValidation({...validation, dob: true}) :
                        updateValidation({...validation, dob: false});
                  }}
                />
                <div style={{display: "flex", justifyContent: "center", marginTop: 10}}>
                    <h5>Policy Premium(Incl GST)  &#8377;152</h5>
                </div>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: 10}}>
                    <div style={{fontSize: 12, color: COLOR.GRAY}}>
                        Insured by
                    </div>
                    <div>
                        <img
                            src={`${imageBaseUrl}/covid19/Edelweiss-hospicash-logo.png`}
                            className="icici-logo"
                            alt="Edelweiss hospicash logo"
                        />
                    </div>
                </div>
                <div style={{display: "flex", justifyContent: "center", marginTop: 10, fontSize: 12}}>
                    <div className="hover" style={{color: COLOR.PRIMARY}}
                         onClick={() => downloadPDF(`${websiteUrl}/insurance/hospicash-Edelweiss.pdf`, "hospicash-Edelweiss", props.isAndroid)}>
                             Download Policy Terms
                    </div>
                </div>
                <div className="consent-wrapper">
                    <div>
                        <input type="checkbox"
                               onChange={() => toggleAgreeementCheckbox(!agreementChecked)}
                               name="terms"
                               className="position-relative mx-1"
                               style={{top: "2px"}}
                        />
                    </div>
                    <div className="consent-text">
                        I confirm that the information in this form is correct.
                    </div>
                </div>
                <div style={{marginTop: 10}}>
                    <Button
                        buttonText={"Proceed"}
                        onClick={handleProceed}
                        rounded={true}
                        width="auto"
                        size={SIZE.LARGE}
                        isDisabled={
                            !agreementChecked || !validation.name || !validation.dob || !validation.relationShip
                        }
                    />
                </div>
            </div>
        </ConsentBox>
    );
};

export default InsuranceBundle;
